import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function HeaderButtons() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const username = localStorage.getItem('username') || 'Usuario';

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
    window.location.reload();
  };

  return (
    <div style={navContainerStyle}>
      
      {/* Botón de Carrito (Siempre visible) */}
      <button style={btnSimpleStyle}>
        <i className="fa-solid fa-cart-shopping"></i> Carrito
      </button>

      {!token ? (
        <button onClick={() => navigate('/login')} style={btnLoginStyle}>Login</button>
      ) : (
        <div style={{ position: 'relative' }} ref={menuRef}>
          {/* Avatar / Botón que activa la pestaña flotante */}
          <div onClick={() => setShowMenu(!showMenu)} style={avatarStyle}>
            {username.charAt(0).toUpperCase()}
          </div>

          {/* PESTAÑA FLOTANTE (Dropdown) */}
          {showMenu && (
            <div style={dropdownStyle}>
              <div style={userInfoSection}>
                <div style={avatarLargeStyle}>{username.charAt(0).toUpperCase()}</div>
                <p style={{ margin: '10px 0 0', fontWeight: 'bold', color: '#fff' }}>¡Hola, {username.toUpperCase()}!</p>
                <p style={{ fontSize: '12px', color: '#aaa', marginBottom: '15px' }}>{role.toUpperCase()}</p>
                <button onClick={() => navigate('/perfil')} style={manageAccountBtn}>
                  Gestionar tu cuenta
                </button>
              </div>

              <div style={menuOptionsSection}>
                {role === 'admin' && (
                  <div onClick={() => navigate('/admin')} style={optionItemStyle}>
                    <i className="fa-solid fa-user-tie" style={{ marginRight: '10px' }}></i> Panel Administrador
                  </div>
                )}
                {role === 'dj' && (
                  <div onClick={() => navigate('/dj-dashboard')} style={optionItemStyle}>
                    <i className="fa-solid fa-compact-disc" style={{ marginRight: '10px' }}></i> Panel DJ
                  </div>
                )}
                <div onClick={() => navigate('/mis-compras')} style={optionItemStyle}>
                  <i className="fa-solid fa-bag-shopping" style={{ marginRight: '10px' }}></i> Mis Compras
                </div>
              </div>

              <div style={logoutSection}>
                <button onClick={handleLogout} style={btnLogoutAction}>
                  <i className="fa-solid fa-right-from-bracket"></i> Cerrar sesión
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ESTILOS DE LA NAVBAR Y PESTAÑA
const navContainerStyle = { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px', padding: '15px 40px', position: 'relative', zIndex: 2000 };
const btnSimpleStyle = { background: 'none', border: '1px solid #fff', color: '#fff', padding: '8px 15px', borderRadius: '20px', cursor: 'pointer', fontSize: '14px' };
const btnLoginStyle = { backgroundColor: '#FFD700', color: '#000', border: 'none', padding: '8px 25px', borderRadius: '20px', fontWeight: 'bold', cursor: 'pointer' };
const avatarStyle = { width: '40px', height: '40px', backgroundColor: '#FF8C00', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', cursor: 'pointer', fontSize: '18px', border: '2px solid #333' };

// ESTILOS DEL DROPDOWN (ESTILO GOOGLE/WIX)
const dropdownStyle = { position: 'absolute', top: '50px', right: '0', width: '300px', backgroundColor: '#1a1a1a', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.8)', border: '1px solid #333', overflow: 'hidden', textAlign: 'center' };
const userInfoSection = { padding: '25px', borderBottom: '1px solid #333' };
const avatarLargeStyle = { width: '60px', height: '60px', backgroundColor: '#FF8C00', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '24px', margin: '0 auto' };
const manageAccountBtn = { backgroundColor: 'transparent', border: '1px solid #555', color: '#fff', padding: '8px 15px', borderRadius: '20px', cursor: 'pointer', fontSize: '13px' };
const menuOptionsSection = { padding: '10px 0' };
const optionItemStyle = { padding: '12px 20px', color: '#fff', textAlign: 'left', cursor: 'pointer', fontSize: '14px', transition: '0.2s', display: 'flex', alignItems: 'center' };
const logoutSection = { padding: '15px', backgroundColor: '#111' };
const btnLogoutAction = { background: 'none', border: 'none', color: '#ff4d4d', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' };

export default HeaderButtons;